// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import $ from './assets/jquery.min.js';
import bootstrap from './assets/bootstrap/dist/js/bootstrap.js';
import collapse from './assets/bootstrap/js/collapse.js';

import './assets/bootstrap/dist/css/bootstrap.css';
import home from './components/home/home';
import system from './components/system/system';
import corefuntion from './components/corefuntion/corefuntion';
import customercase from './components/customercase/customercase';
import aboutus from './components/aboutus/aboutus';
import hardware from './components/hardware/hardware';
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.config.productionTip = false;
/* eslint-disable no-new */
/* let app = Vue.extend(App); */
const routes = [{
  path: '/',
  redirect: '/home'
}, {
  path: '/home',
  component: home,
  meta: { title: '云医馆-中药堂智慧服务系统-首页',keywords: '云医馆,云标中医馆,云中医馆,云医管,中医诊所管理软件,云标中药堂管理系统,中医管理系统,中医门诊管理系统,中医馆管理软件,中医诊所管理系统,中医预约管理系统,国医馆管理系统,中医预约管理系统,中医馆自助预约,中医诊所系统,中医预约系统,预约挂号,排队分诊,医生选择,自助式医疗服务,自助预约挂号机,',description: '云标中药堂智慧服务系统，由北京云标科技有限公司为祖国传统中药诊所实现信息化管理，提高中医药堂智慧化管理而量身打造的一套中药堂管理系统。该系统一站式解决预约挂号、排队分诊、选择医生、便捷支付、就诊评价、医疗数据统计等问题' }
}, {
  path: '/system',
  component: system,
  meta: {title: '云医馆-系统优势-中药堂智慧服务系统', keywords: '云医馆,云标中医馆,云中医馆,云医管,中医诊所管理软件,云标中药堂管理系统,中医管理系统,中医门诊管理系统,中医馆管理软件,中医诊所管理系统,中医预约管理系统,国医馆管理系统,中医预约管理系统,中医馆自助预约,中医诊所系统,中医预约系统,新零售智慧药店,预约挂号系统,云标中药系统功能列表,',description: '云标中药堂智慧服务系统，线上预约挂号支付，线下自助取号就诊，创新的店铺管理模式，高效便捷的就医流程，安全、稳定、高效的运行系统，多维度提升中药堂管理水平。' }
}, {
  path: '/corefuntion',
  component: corefuntion,
  meta: {title: '云医馆-核心功能-中药堂智慧服务系统',keywords :'云医馆,云标中医馆,云中医馆,云医管,中医诊所管理软件,云标中药堂管理系统,中医管理系统,中医门诊管理系统,中医馆管理软件,中医诊所管理系统,中医预约管理系统,国医馆管理系统,中医预约管理系统,中医馆自助预约,中医诊所系统,中医预约系统,新零售智慧药店,预约挂号系统,云标中药系统功能列表,',description: '云标中药堂智慧服务系统，包含四大模块，五十余项功能，从预约挂号、药店管理、数据统计等形成完整的管理体系，从自助机到药房、医生，到手机微信端到网站后台的数据分析与管理形成全面的闭环衔接' }
}, {
  path: '/aboutus',
  component: aboutus,
  meta: {title: '云医馆-关于我们-中药堂智慧服务系统',keywords :'云医馆,云标中医馆,云中医馆,云医管,中医诊所管理软件,云标中药堂管理系统,医院自助服务一体机,同仁堂预约挂号系统,人川大药房自助预约取号系统，海南口腔医院排队叫号系统，清华玉泉医院导览查询展示系统,方舟医院分诊叫号系统',description: '云标中药堂智慧服务系统，是北京云标科技有限公司旗下一套以中医药+互联网为核心，为方便患者预约挂号为初衷，同时便于院方提升管理而研发的一套集自助机预约挂号、移动便捷支付、药房管理、医生管理、会员管理、电子药方、数据统计分析等功能为一体的全流程闭环管理系统。' }
}, {
  path: '/customercase',
  component: customercase,
  meta: { title: '云医馆-客户案例-中药堂智慧服务系统',keywords :'云医馆,云标中医馆,云中医馆,云医管,中医诊所管理软件,云标中药堂管理系统,医院自助服务一体机,同仁堂预约挂号系统,人川大药房自助预约取号系统，海南口腔医院排队叫号系统，清华玉泉医院导览查询展示系统,方舟医院分诊叫号系统,',description: '云标中药堂智慧服务系统，便捷的预约挂号、取号、医生信息查询、店铺地图、按病寻医、电子病历等功能为北京同仁堂、赤峰人川大药房、海南口腔医院、清华玉泉医院、北京方舟医院等管理提供了强有力支持。' }

}, { path: '/hardware',
  component: hardware,
  meta: {title: '云医馆-硬件配套-中药堂智慧服务系统',keywords :'云医馆,云标中医馆,云中医馆,云医管,中医诊所管理软件,云标中药堂管理系统,医院自助服务一体机,医院信息屏，排队叫号机,叫号显示屏,医院触摸查询,医院数字化展板,医院自助服务,',description: '云标中药堂智慧服务系统包含自助服务机，实现预约挂号、取号、医生信息查询、店铺地图、按病寻医、电子病历等功能，立式广告机、壁挂广告机等用于医院导视、科室介绍、通知公告，还可以实现排队叫号，医疗分诊等功能。' }
}, {
  path: '*',
  redirect: '/home',
  meta: { title: '云医馆-中药堂智慧服务系统-首页' }
}
];
const router = new VueRouter({
  linkActiveClass: 'active',
  routes,
  mode:"history",
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
// 全局关键词
router.beforeEach((to, from, next) => {
  // Change doc title
  document.title = to.meta.title || 'Unknow title';
  document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords);
  document.querySelector('meta[name="description"]').setAttribute('content',  to.meta.description);
  next();
})



// WEBPACK FOOTER //
// ./src/main.js